import React from 'react';

import { cn } from '~/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  /** Padding vertical adicional (ex: py-8) */
  verticalPadding?: string;
}

/**
 * Container reutilizável para páginas que centraliza conteúdo
 * apenas em telas wide (2xl+) e aplica padding responsivo
 */
export function PageContainer({
  children,
  className,
  verticalPadding
}: PageContainerProps) {
  return (
    <div
      className={cn(
        'px-4 sm:px-6 lg:px-8 2xl:max-w-7xl 2xl:mx-auto',
        verticalPadding,
        className
      )}>
      {children}
    </div>
  );
}
